import payroll_cycle from './payrollCycle.js';
import payroll_computation from './payrollComputation.js';
import payslip from './payslip.js';
import fnfpayslip from './fnfpayslips.js';
import salary_component from './salaryComponent.js';
import salary_structure from './salaryStructure.js';
import salary_component_types from './salaryComponentTypes.js';
import paydaysinmonth from './payDaysinmonth.js';

export default {
  namespaced: true,
  modules: {
    payroll_cycle: payroll_cycle,
    payroll_computation: payroll_computation,
    payslip: payslip,
    salary_component: salary_component,
    salary_component_types: salary_component_types,
    salary_structure: salary_structure,
    paydaysinmonth:paydaysinmonth,
    fnfpayslip: fnfpayslip
  }
};
